/* eslint-disable @typescript-eslint/naming-convention */
export enum LogLevel {
	Info = 0,
	Warning = 1,
	Error = 2,
	Off = 3
}
